module.exports = __webpack_public_path__ + "img/radio-selangor.c3b66db5.jpg";